import { createContext } from 'react';
import api from '../api';
import { getContextDefaultValues } from '../../providersDataManager';
export default createContext(getContextDefaultValues(api));
